/*
 * Module for handling the properties of a response (belonging to a conversation node,
 * branching or not).
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicResponse/topicResponseProperties/topicResponsePropertiesView",
  "modules/shared/contentMappingModal/contentMappingModalModule",
  "jquery",
], function (
  Marionette,
  Backbone,
  Messenger,
  TopicResponsePropertiesView,
  ContentMappingModalModule,
  $,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicResponseProperties";
      this.region = options.region;
      this._setUpVents();
    },
    show: async function (conversationNode, readOnly, reviewer) {
      this.conversationNode = conversationNode;
      readOnly = readOnly || Messenger.reqres.request("topic:read:only");
      const model = new Backbone.Model({
        nodeToUse: conversationNode, //either the pending or live conversation node
        showPublishedResponse: false,
        readOnly: readOnly,
        reviewer: reviewer,
        associatedContent: null,
      });
      this.view = new TopicResponsePropertiesView.topicResponsePropertiesView({ model: model });

      const kbModel = Messenger.reqres.request("active:kb:model");
      await Promise.all([kbModel.onSyncedPromise(), conversationNode.onSyncedPromise()]);

      this.view.model.conversations = kbModel.get("conversations");

      this.view.on(
        "create:conversation",
        function () {
          const examples = Messenger.reqres.request("current:topic:examples");
          if (examples.models.length > 0) {
            Messenger.vent.trigger("create:conversation");
          } else {
            Messenger.okDialog($.t("topic.examples.noExamplesError"));
          }
        },
        this,
      );
      this.view.on(
        "change:escalation",
        function (type) {
          console.log("change escalation");
          this.conversationNode.setEscalation(type);
        },
        this,
      );

      //associated content event handlers
      //save the topic, and then load the content page for the assoc. content
      this.view.on(
        "click:associated:content",
        function () {
          //make sure that the link isn't read only
          if (!this.readOnly) {
            Messenger.save(function (success) {
              if (success) {
                Messenger.vent.trigger(
                  "show:content",
                  this.conversationNode.getAssociatedContent(),
                );
              }
            }, this);
          }
        },
        this,
      );

      this.view.on(
        "edit:associated:content",
        function () {
          const topicId = Messenger.reqres.request("current:topic:id");
          Messenger.save((success) => {
            if (success) {
              //open up content mapping modal
              Messenger.vent.trigger(
                "show:modal",
                ContentMappingModalModule,
                {},
                this.conversationNode,
                {
                  title: "topic.responseProperties.associatedContent",
                  closeButton: true,
                  closeOnBackgroundClick: false,
                  trackInteraction: {
                    action: "Topic Associated Content",
                    id: topicId,
                    idType: "Topic",
                    object: "Topic",
                  },
                },
              );
            }
          });
        },
        this,
      );
      this.view.on(
        "delete:associated:content",
        function () {
          Messenger.yesNoDialog(
            "topic.responseProperties.removeAssociatedContentMessage",
            {
              yes: () => {
                const topicId = Messenger.reqres.request("current:topic:id");
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete Topic Associated Content",
                  id: [topicId, this.conversationNode.getAssociatedContent().id],
                  idType: ["Topic", "Content"],
                  object: "Topic Associated Content",
                });
                this.conversationNode.deleteAssociatedContent();
              },
            },
            this,
          );
        },
        this,
      );

      this._getContent();
      this.showRegion(this.view);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "conversation:changed",
        function () {
          this.show(this.conversationNode);
        },
        this,
      );
      Messenger.vent.on(
        "topic:response:changed",
        function () {
          this._getContent();
        },
        this,
      );
      Messenger.vent.on(
        "response:type:changed",
        function (showPublishedResponse, nodeToUse) {
          this.view.model.set("showPublishedResponse", showPublishedResponse);
          this.view.model.set("nodeToUse", nodeToUse);
          //fetch the associated content model, if necessary
          this._getContent();
        },
        this,
      );
      //Listen for changes in the selected touchpoint and locale
      Messenger.vent.on(
        "selected:response:template",
        function () {
          this._getContent();
        },
        this,
      );
    },
    _getContent: function () {
      let content;
      try {
        const touchPointId = Messenger.reqres.request("selected:response:touchPointId");
        const localeId = Messenger.reqres.request("selected:response:localeId");
        content = this.view.model.get("nodeToUse").getAssociatedContent(touchPointId, localeId);
      } catch (e) {
        console.error("Failed to get the associated content: ", e);
      }
      if (content) {
        content.onSynced(function () {
          this.view.model.set("associatedContent", content);
        }, this);
      } else {
        this.view.model.set("associatedContent", null);
      }
    },
  });
});
